<template>
  <div id="classDetailsDiv">
    <div class="classDetailsDiv_content">
      <div class="head_title class_head_title">
        <div class="head_title_font class_head_title_font">
          <span>考勤统计</span>
        </div>
        <div class="searcharea">
          <label >时间筛选:</label>
          <input type="text" class="form-control" name="chooseStartDate" id="chooseStartDate" style="width: 120px;display: inline-block" v-model="searchParams.checkDate" readonly>
          —
          <input type="text" class="form-control" name="chooseEndDate" id="chooseEndDate" style="width: 120px;display: inline-block" v-model="searchParams.checkDateTo" readonly>
          <label>教师姓名:</label>
          <input type="text" class="form-control" name="chooseStartDate" style="width: 100px;display: inline-block" v-model="searchParams.teacherName">
          <button type="button" class="btn btn-default btn_option" style="height: 28px;line-height: 15px" @click="initStatisticsListData()">查询</button>
          <button type="button" class="btn btn-default btn_option"
                  style="height: 28px;line-height: 15px"
                  @click="exportStatistics()">导出</button>
        </div>
      </div>
      <div class="body_content class_body_content">
        <div class="classStatisticsList_div">
          <table class="table table-striped table-bordered table_classStatistics">
            <thead>
            <tr>
              <th width="5%">序号</th>
              <th width="20%">姓名</th>
              <th width="20%">签到/迟到(次数)</th>
              <th width="20%">签退/早退(次数)</th>
              <th width="10%">查看详情</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in statisticsList" :key="index">
              <td width="5%">
                {{index + 1}}
              </td>
              <td width="20%">{{item.teacherName}}</td>
              <td width="20%">{{item.inNum}}/{{item.lateNum}}</td>
              <td width="20%">{{item.outNum}}/{{item.earlyNum}}</td>
              <td width="10%">
                <div class="details_pic" @click="showDetailMode(item.teacherId,item.teacherName)"></div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog dialog-work">
        <div class="modal-content modal-work-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">{{showTeacherName}}</h4>
          </div>
          <div class="modal-body modal_work_details">
            <table class="table table-bordered table-striped table_details">
              <thead>
              <tr>
                <th>日期</th>
                <th>签到</th>
                <th>签退</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in detailsList" :key="index">
                <td>{{item.checkDate}}</td>
                <td>{{item.inTime}} <span style="color: red"> {{item.inResult | statusIn}}</span></td>
                <td>{{item.outTime}} <span style="color: red">{{item.outResult | statusOut}}</span></td>
              </tr>
              </tbody>
            </table>
            <page-view v-bind="searchParams"></page-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";
  import {getContentSize} from './mainView';
  import pageView from './pageView';
  export default {
    name: "classStatistics",
    components:{pageView},
    data() {
      return {
        //教务领导
        leaderUserCode: this.$store.state.leaderUserCode,
        userCode: this.$store.state.userCode,

        //今日日期
        timeDate: '',

        //课时统计集合
        statisticsList:[],

        //单个教师详情集合
        detailsList:[],

        searchParams:{
          teacherId:'',
          teacherName:'',
          checkDate:'',
          checkDateTo:'',
          all: 0,
          rows: 15,
          page:1
        },

        showTeacherName:"",
        token: this.$store.state.access_token,
        hrefExport:this.$store.state.serviceBase+"resources/",
      }
    },

    filters: {
      statusIn(v){
        if(v == '2')
          return "(迟到)"
      },
      statusOut(v){
        if(v == '2')
          return "(早退)"
      },
    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        //日期
        this_.dateDefault();
        this_.searchParams.checkDate = this_.formatDate(new Date(),'yyyy-MM-dd');
        this_.searchParams.page = 1;
        this_.searchParams.pageCallback = this_.initDetailsList;
        this_.closeModal();
        this_.initStatisticsListData();
      });
    },
    methods: {
      /**
       * 课时统计列表
       */
      initStatisticsListData(){
        let this_ = this;
          schoolAxios({
            method: 'get',
            url: 'attendanceTeacher/statistics',
            params: {
              "teacherName":this_.searchParams.teacherName,
              "checkDate":this_.searchParams.checkDate,
              "checkDateTo":this_.searchParams.checkDateTo
            }
          }).then(function (resp) {
            if (resp.data.success) {
              this_.statisticsList = resp.data.list;
            }else{
              resp.data.message.showMessage();
            }
          });
      },

      /**
       * 详情
       */
      initDetailsList(pageParams){
        let this_=this;
        if(pageParams)
          Object.assign(this_.searchParams, pageParams);

        let _searchParams = {};
        Object.assign(_searchParams, this_.searchParams);
        delete _searchParams.pageCallback;//提交前删除回调
          schoolAxios({
            method: 'get',
            url: 'attendanceTeacher/findPage',
            params:_searchParams
          }).then(function (response) {
            // console.info(response);
            let data = response.data;
            if (data.success) {
              this_.detailsList = data.list;
              this_.searchParams.all = response.data.totalPage;
            }else{
              data.message.showMessage();
            }
          });
       
      },
      showDetailMode(teacherId, teacherName){
        let this_=this;
        this_.searchParams.teacherId = teacherId;
        this_.showTeacherName = teacherName;
        this_.initDetailsList();
        $("#myModal").modal("show");
      },
      /**
       * 初始化日期选择框
       */
      dateDefault(){
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";
        nowDate += (date.getMonth() + 1) + "-";
        nowDate += date.getDate() + " ";
        this_.timeDate = nowDate;
        $('#chooseStartDate').datetimepicker({
          minView: "month",//选择日期后，不会再跳转去选择时分秒
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //checkDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,//选择一个日期后是否立即关闭此选择框
          todayHighlight: true,//高亮当前日期
          startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#chooseStartDate").val();
          this_.searchParams.checkDate = value;
          ev.preventDefault();
          ev.stopPropagation();
        });
        $('#chooseEndDate').datetimepicker({
          minView: "month",
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //checkDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,
          todayHighlight: true,
          startView: 2,
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#chooseEndDate").val();
          this_.searchParams.checkDateTo = value;
          ev.preventDefault();
          ev.stopPropagation();
        });

      },



      /**
       * 导出
       */
      exportStatistics(){
        let this_=this;
        schoolAxios({
          method: 'get',
          url:'attendanceTeacher/exportStatistics',
          params: {
            "teacherName":this_.searchParams.teacherName,
            "checkDate":this_.searchParams.checkDate,
            "checkDateTo":this_.searchParams.checkDateTo
          }
        }).then(function (response) {
          if(response.data.success){
            location.href=this_.hrefExport+response.data.data;
          }else
            (response.data.message||"导出失败").showMessage();
        });
      },

      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $("#myModal").on('hide.bs.modal', function () {
          this_.showTeacherName = '';
          this_.searchParams.page = 1;
          this_.searchParams.all = 0;

        });

      },
      formatDate(value, fmt){
        if(!value) return;
        var o = {
          'M+': value.getMonth() + 1, // 月份
          'd+': value.getDate(), // 日
          'h+': value.getHours(), // 小时
          'm+': value.getMinutes(), // 分
          's+': value.getSeconds(), // 秒
          'q+': Math.floor((value.getMonth() + 3) / 3), // 季度
          'S': value.getMilliseconds() // 毫秒
        }
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (value.getFullYear() + '').substr(4 - RegExp.$1.length))
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))

        }
        return fmt
      },

    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  .table_classStatistics {
    margin: 15px 0 0 0;
  }
  table tr{
    text-align: center;
  }
  table th {
    background: #cccccc;
    text-align: center;
  }
  .table-striped {
    /*background-color: #D7D7D7;*/
  }
  .details_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/workLoad/details_mouseOver.png");
    background-size: 100% 100%;
    margin: 0 0 0 45%;
  }
  .edit_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/edit_mouseOver.png");
    background-size: 100% 100%;
    cursor: pointer;
    float: left;
    margin: 0 0 0 15px;
  }
  .delete_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/delete_mouseOver.png");
    background-size: 100% 100%;
    cursor: pointer;
    float: left;
    margin: 0 0 0 20px;
  }
  .form-group-div {
    margin-top: 10px;
  }
  .form-group label {
    width: 100px;
  }
  .modal-content.modal-work-content {
    width: 900px;
  }
  .modal-content.modal-content-update {
    width: 300px;
    margin: 220px 0 0 300px;
  }
  .table_details tbody{
  }
  .table_classStatistics tbody{
  }
  input.form-control.scheduleInfo {
    display: inline-block;
    width: 80%;
    margin-top: 10px;
  }
  #time_div {
    position: absolute;
    left: 15%;
    width: 76%;
    border: 1px grey solid;
    background-color: white;
    display: none;
    z-index: 1;
  }
  #time_div option {
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  #time_div option:hover {
    background-color: grey;
  }
  /*表头固定*/
  .table_details tbody{
  }

  .table_classStatistics tbody{
  }

  .searcharea{
    position: absolute;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/attendanceTeacher.vue